import type { ComponentProps } from "react";

import { cn } from "@/lib/helpers/cn";

export function Card2({ className, ...sectionProps }: ComponentProps<"section">) {
  return (
    <section
      className={cn("tw:flex tw:rounded-md tw:bg-fill-white tw:shadow-lg", className)}
      {...sectionProps}
    />
  );
}
